import { Fragment, ReactNode } from "react";

export const renderTextWithLineBreaks = (text: string): ReactNode => {
  return text.split("\n").map((line, index, lines) => (
    <Fragment key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </Fragment>
  ));
};
